import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CustomSnackBarComponent } from './components/custom-snack-bar/custom-snack-bar.component';

@NgModule({
	declarations: [CustomSnackBarComponent],
	imports: [CommonModule, MatIconModule, MatButtonModule],
	exports: [CustomSnackBarComponent],
})
export class SharedModule {}
